import React, { Component } from "react";

export default class CommunicationDetails extends Component {
  render() {
    return <div></div>;
  }
}
